import { Button, Grid, StepperLines, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { messages } from './AdditionalScreen.messages';
import { Image } from './AdditionalScreen.styles';
import { AdditionalScreenProps } from './AdditionalScreen.types';

export const AdditionalScreen: FC<AdditionalScreenProps> = memo((props) => {
    const { items, stepsCount, currentStep, isLast, onNext, onGoToSetup } = props;

    return (
        <Grid gap={32}>
            <StepperLines stepsCount={stepsCount} currentStep={currentStep} />

            <Grid gap={24} gridTemplateColumns={`repeat(${items.length},  minmax(0, 202px))`} justifyContent='center'>
                {items.map(({ imageSrc, description }, index) => (
                    <div key={index}>
                        <Image src={imageSrc} alt='' />

                        <Text font='label' fontSize='large' spacing='10 0 0'>
                            {description}
                        </Text>
                    </div>
                ))}
            </Grid>

            {isLast ? (
                <Grid justifyContent='center'>
                    <Button color='blue80' size='large' block onClick={onNext}>
                        {messages.explore}
                    </Button>
                </Grid>
            ) : (
                <Grid gridTemplateColumns='repeat(2, max-content)' gap={40} justifyContent='end'>
                    <Button variant='text' color='blue100' size='large' block onClick={onGoToSetup}>
                        {messages.goToSetup}
                    </Button>

                    <Button color='blue80' size='large' block onClick={onNext}>
                        {messages.next}
                    </Button>
                </Grid>
            )}
        </Grid>
    );
});

AdditionalScreen.displayName = 'AdditionalScreen';
